/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { QuestionConflictsControllerResolveMutationResponse, QuestionConflictsControllerResolvePathParams } from "../../models/checklistsController/QuestionConflictsControllerResolve";

function getQuestionConflictsControllerResolveUrl(id: QuestionConflictsControllerResolvePathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/checklist-question-conflicts/${id}/resolve` as const }  
  return res
}

/**
 * @description Requires Edit reviews or Edit Playbooks (matching the parent application's template kind) — the same permission that controls answering questions on that application.
 * @summary Dismiss a conflict
 * {@link /api/v1/checklist-question-conflicts/:id/resolve}
 */
export async function questionConflictsControllerResolve(id: QuestionConflictsControllerResolvePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<QuestionConflictsControllerResolveMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getQuestionConflictsControllerResolveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}